import { render, staticRenderFns } from "./TopBarDropdown.vue?vue&type=template&id=58494568&scoped=true"
import script from "./TopBarDropdown.vue?vue&type=script&lang=js"
export * from "./TopBarDropdown.vue?vue&type=script&lang=js"
import style0 from "./TopBarDropdown.vue?vue&type=style&index=0&id=58494568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58494568",
  null
  
)

export default component.exports